// extracted by mini-css-extract-plugin
module.exports = {"container":"SIh-b","titleInputWrapper":"_2NbLu","titleInputContainer":"vmc6C","titleInput":"_2js1p","content":"_2ksTM","editor":"LYA0o"};